
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Pginpune() {



    const cardData =
    {
        keyword: 'PG in Pune',
        heading: 'Shree Swami Samarth PG :  PG in Pune',
        headingDescription: 'Shree Swami Samarth PG provides comfortable and affordable PG accommodation in Pune, offering a homely environment for students, working professionals, and corporate employees. Our fully furnished rooms are spacious, well-maintained, and equipped with essential amenities such as high-speed WiFi, 24x7 water supply, healthy meals, and CCTV security, ensuring a safe and convenient stay. With prime locations across the city, we make daily commutes easier for residents working in IT hubs like Hinjewadi, Magarpatta, and Kharadi. Regular housekeeping, hygienic facilities, and disciplined management make us the preferred choice for those seeking hassle-free living. Whether you’re looking for short-term or long-term accommodation, Shree Swami Samarth PG in Pune offers reliable, cost-effective, and comfortable living solutions tailored to modern lifestyle needs.',

        top: 'Top Facilities at Shree Swami Samarth PG ',

"topFacilities": [
  {
    "title": "Fully Furnished Rooms",
    "description": "Spacious and neatly maintained rooms equipped with comfortable beds, study tables, chairs, wardrobes, and proper ventilation. Each room is designed to provide a homely yet professional environment, perfect for students and working professionals."
  },
  {
    "title": "Nutritious Meals",
    "description": "Daily hygienic and home-style meals served with a balanced diet plan. The PG offers breakfast, lunch, and dinner, ensuring residents enjoy healthy and tasty food that reminds them of home."
  },
  {
    "title": "24/7 Security",
    "description": "The premises are secured with CCTV surveillance and responsible staff available round the clock. Strict visitor entry rules ensure safety and peace of mind for all residents."
  },
  {
    "title": "High-Speed Wi-Fi",
    "description": "Uninterrupted internet connectivity available across all rooms and common areas. Ideal for students attending online classes and professionals working remotely."
  },
  {
    "title": "Housekeeping & Laundry",
    "description": "Regular cleaning and housekeeping services keep the premises spotless. Laundry facilities are also provided, ensuring residents maintain cleanliness and hygiene with ease."
  },
  {
    "title": "Prime Location",
    "description": "Located in the heart of Pune, the PG is well-connected to colleges, IT parks, corporate hubs, and shopping areas. Easy access to public transport makes commuting hassle-free."
  },
  {
    "title": "Recreational Facilities",
    "description": "Common lounge with TV, indoor games, and reading corners for relaxation and leisure. The PG focuses on providing a balanced lifestyle with both study and recreation."
  },
  {
    "title": "Affordable Pricing",
    "description": "Transparent rental structure with no hidden costs. The PG offers multiple room-sharing options to suit different budgets, making it affordable for both students and professionals."
  }
],



"services": [
  {
    "name": "PG in Pune",
    "description": "Shree Swami Samarth PG offers comfortable and secure PG accommodation in Pune with modern amenities, ideal for students and working professionals seeking a home-like stay."
  },
  {
    "name": "Single Room PG in Pune",
    "description": "Experience privacy and peace with Shree Swami Samarth PG’s single room options in Pune. Perfect for individuals who prefer a quiet and independent living space."
  },
  {
    "name": "Best PG in Pune",
    "description": "Ranked among the best PGs in Pune, Shree Swami Samarth PG provides top-tier facilities, cleanliness, and a welcoming environment for hassle-free living."
  },
  {
    "name": "Affordable PG in Pune",
    "description": "Enjoy budget-friendly living with Shree Swami Samarth PG’s affordable PG options in Pune—combining comfort, safety, and essential amenities without breaking the bank."
  },
  {
    "name": "Monthly Basis PG in Pune",
    "description": "Shree Swami Samarth PG offers flexible monthly rental options in Pune, allowing short-term and long-term stays tailored to student or professional schedules."
  },
  {
    "name": "Shared PG in Pune",
    "description": "Shree Swami Samarth PG features clean and spacious shared rooms in Pune, ideal for roommates looking to save on rent while enjoying a sociable environment."
  },
  {
    "name": "Girls PG in Pune",
    "description": "Secure and comfortable, Shree Swami Samarth Girls PG in Pune is designed for female students and professionals, offering safety, privacy, and convenience."
  },
  {
    "name": "Boys PG in Pune",
    "description": "Shree Swami Samarth Boys PG in Pune provides fully furnished rooms, hygienic food, and a reliable atmosphere for male tenants looking for quality accommodation."
  },
  {
    "name": "Luxury PG in Pune",
    "description": "Upgrade your stay with Shree Swami Samarth’s luxury PG in Pune—featuring premium interiors, AC rooms, Wi-Fi, and other upscale amenities for a refined experience."
  },
  {
    "name": "Furnished PG in Pune",
    "description": "Shree Swami Samarth PG in Pune offers fully furnished rooms with beds, wardrobes, study tables, and more—ready for immediate move-in with no setup hassles."
  },
  {
    "name": "PG Accommodation in Pune",
    "description": "Find reliable PG accommodation in Pune with Shree Swami Samarth PG—serving students and professionals with clean living spaces, meals, and friendly support."
  },
  {
    "name": "PG Near Hinjewadi",
    "description": "Located near Hinjewadi IT Park, Shree Swami Samarth PG is ideal for tech professionals seeking convenient and affordable housing with quick office access."
  },
  {
    "name": "PG Near Magarpatta",
    "description": "Shree Swami Samarth PG near Magarpatta City offers strategic accommodation for students and working professionals close to major corporate hubs."
  },
  {
    "name": "PG for Students in Pune",
    "description": "Shree Swami Samarth PG in Pune provides a student-friendly environment with study zones, nutritious meals, and supportive facilities for focused learning."
  },
  {
    "name": "PG for Working Professionals in Pune",
    "description": "Designed for working individuals, Shree Swami Samarth PG in Pune offers peaceful surroundings, high-speed internet, and flexible services to suit busy schedules."
  }
],
"tableData": [
  ["PG in Pune", "Single Room PG in Pune"],
  ["Best PG in Pune", "Affordable PG in Pune"],
  ["Monthly Basis PG in Pune", "Shared PG in Pune"],
  ["Girls PG in Pune", "Boys PG in Pune"],
  ["Luxury PG in Pune", "Furnished PG in Pune"],
  ["PG Accommodation in Pune", "PG Near Hinjewadi"],
  ["PG Near Magarpatta", "PG for Students in Pune"],
  ["PG for Working Professionals in Pune", ""]
],





"whychoose": [
    {
        "WhyChooseheading": "Comfortable and Affordable PG in Pune",
        "WhyChoosedescription": "Shree Swami Samarth PG offers well-furnished, budget-friendly accommodations for students and working professionals looking for a reliable PG in Pune. Enjoy a peaceful stay with all essential amenities included."
    },
    {
        "WhyChooseheading": "Prime Locations Across Pune",
        "WhyChoosedescription": "Our PGs are strategically located near major IT parks, colleges, and commercial hubs like Hinjewadi, Viman Nagar, and Kharadi  daily commuting easy and stress-free."
    },
    {
        "WhyChooseheading": "Fully Furnished Rooms with Modern Amenities",
        "WhyChoosedescription": "Each room in our PG is equipped with a bed, wardrobe, study table, and high-speed Wi-Fi. Residents also have access to common areas, RO drinking water, hot showers, and regular housekeeping services."
    },
    {
        "WhyChooseheading": "Safe and Secure PG in Pune",
        "WhyChoosedescription": "Your safety is our top priority. Shree Swami Samarth PG offers 24/7 security, CCTV surveillance, biometric entry systems, and live-in wardens to ensure a secure and comfortable living environment."
    },
    {
        "WhyChooseheading": "Homely Food with Hygienic Meal Plans",
        "WhyChoosedescription": "We provide nutritious, home-cooked meals served fresh daily. Our meal plans are designed to suit different dietary preferences while maintaining hygiene and quality standards."
    },
    {
        "WhyChooseheading": "Separate PGs for Boys and Girls",
        "WhyChoosedescription": "Shree Swami Samarth PG provides separate accommodations for male and female residents, with privacy and comfort as a core part of the living experience."
    },
    {
        "WhyChooseheading": "Flexible Rental Plans and Transparent Pricing",
        "WhyChoosedescription": "Choose from monthly, quarterly, or yearly plans that fit your budget. No hidden charges—just clear, upfront pricing with detailed receipts and flexible payment options."
    },
    {
        "WhyChooseheading": "Supportive Staff and 24/7 Assistance",
        "WhyChoosedescription": "Our on-site staff and helpline are available around the clock to handle maintenance requests, emergencies, or any concerns—making Shree Swami Samarth PG one of the most dependable PGs in Pune."
    }
]

















    }

    const faqData = [
    {
        question: "How can I book a PG in Pune at Shree Swami Samarth PG?",
        answer: "You can book a PG at Shree Swami Samarth PG by contacting us directly through phone or visiting our property in Pune. Online booking options are also available upon request."
    },
    {
        question: "What amenities are provided at Shree Swami Samarth PG in Pune?",
        answer: "Our PG in Pune offers amenities such as Wi-Fi, furnished rooms, housekeeping, purified drinking water, CCTV security, and home-cooked meals."
    },
    {
        question: "Is food included in the PG rent at Shree Swami Samarth PG in Pune?",
        answer: "Yes, we provide nutritious home-cooked meals as part of the rent for our PG residents in Pune."
    },
    {
        question: "Do you offer both boys' and girls' PG accommodation in Pune?",
        answer: "Currently, Shree Swami Samarth PG offers separate accommodations for boys and girls in Pune with all essential facilities."
    },
    {
        question: "Is there any security or CCTV surveillance at your PG in Pune?",
        answer: "Yes, our PG premises in Pune are equipped with 24/7 CCTV surveillance to ensure the safety and peace of mind of our residents."
    },
    {
        question: "What is your rent and deposit policy for the PG in Pune?",
        answer: "The rent and deposit vary depending on the room type and amenities. Please contact us for detailed pricing and availability."
    },
    {
        question: "Can I opt for a single occupancy room at Shree Swami Samarth PG in Pune?",
        answer: "Yes, we offer single, double, and triple occupancy rooms to suit your preference and budget."
    },
    {
        question: "Is there any minimum stay requirement at your PG in Pune?",
        answer: "We usually require a minimum stay of one month. However, short-term stays may be accommodated based on availability."
    },
    {
        question: "What is your guest policy at Shree Swami Samarth PG in Pune?",
        answer: "Guests are allowed during specific hours with prior permission, ensuring the comfort and privacy of other residents."
    },
    {
        question: "How can I contact Shree Swami Samarth PG in Pune for inquiries or booking?",
        answer: "You can reach us at +91 9594917913 for bookings and any other inquiries regarding our PG services in Pune."
    }
];

const testimonialsData = [
    {
        name: 'Mr. Rahul Deshmukh',
        designation: 'Software Developer, Hinjewadi IT Park, Pune',
        rating: [1, 1, 1, 1, 1],
        text: 'Staying at Shree Swami Samarth PG has been a hassle-free experience. Clean rooms, great food, and excellent management. Highly recommended for working professionals in Pune.',
    },
    {
        name: 'Miss. Sneha Joshi',
        designation: 'MBA Student, Symbiosis Institute, Pune',
        rating: [1, 1, 1, 1, 1],
        text: 'The PG is well-maintained and safe for girls. The staff is helpful, and the location is ideal for students and working women alike. A peaceful PG in Pune.',
    },
];














    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9209169761",
            "+91 9096665072",

        ],
        email: "reservation@swamisamarthpg.com "
    };


     const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: " PG in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "  Single Room PG in Pune",
        },
        
        {
            place: "/images/keyword/4.jpg",
            text: "  Best Luxury PG in Pune",
        },
       
       
        {
            place: "/images/keyword/13.jpg",
            text: "  Hostel in Pune",
        },

        {
            place: "/images/keyword/15.jpg",
            text: " PG for Working Professionals Pune",
        },
        
        {
            place: "/images/keyword/19.jpg",
            text: "  Paying Guest Near Hinjewadi IT Park Pune",
        },
        

    ];


    const images = [
        { src: "./images/gallery/1.jpg", alt: "Image 1" },
        { src: "./images/gallery/2.jpg", alt: "Image 1" },
        { src: "./images/gallery/3.jpg", alt: "Image 1" },
        { src: "./images/gallery/4.jpg", alt: "Image 1" },
        { src: "./images/gallery/5.jpg", alt: "Image 1" },
        { src: "./images/gallery/6.jpg", alt: "Image 1" },
        { src: "./images/gallery/7.jpg", alt: "Image 1" },
        { src: "./images/gallery/8.jpg", alt: "Image 1" },
        { src: "./images/gallery/9.jpg", alt: "Image 1" },

    ];












const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Shree Swami Samarth PG",
  "image": "https://swamisamarthpg.com/assets/images/pg-image.jpg", // Replace with actual image URL
  "description": "Affordable and furnished PG accommodation in Pune. Ideal for students and working professionals. Located near Hinjewadi and Magarpatta, offering single and shared rooms with monthly rental options.",
  "brand": {
    "@type": "Brand",
    "name": "Shree Swami Samarth PG"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "1500"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "8000",         // Replace with actual price if available
    "availability": "https://schema.org/InStock",
    "url": "https://swamisamarthpg.com/"  // Actual page URL
  }
};



    return (
        <div>

<Helmet>
  <title>PG in Pune | Affordable & Furnished PG for Students & Professionals</title>
  <meta 
    name="description" 
    content="Shree Swami Samarth PG offers affordable and furnished single & shared rooms in Pune. Perfect for students and working professionals near Hinjewadi and Magarpatta. Book monthly basis PG now." 
  />
  <meta 
    name="keywords" 
    content="PG in Pune, Single Room PG in Pune, Best PG in Pune, Affordable PG in Pune, Monthly Basis PG in Pune, Shared PG in Pune, Girls PG in Pune, Boys PG in Pune, Luxury PG in Pune, Furnished PG in Pune, PG Accommodation in Pune, PG Near Hinjewadi, PG Near Magarpatta, PG for Students in Pune, PG for Working Professionals in Pune" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section
                className="page-title"
                style={{
    backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(images/background/3.jpg)`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    color: 'white'
  }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/1.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF6403', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topFacilities.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                          

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Shree Swami Samarth PG</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                {/* <FAQKeyword faqs={faqData} /> */}
                <Accordion data={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #FF6403',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#FF6403' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919209169761" className="d-block  text-white">+91 9209169761</a>
                                                <a href="tel:+919096665072" className="d-block  text-white">+91 9096665072</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#FF6403' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:reservation@swamisamarthpg.com " className=" text-white d-block">
                                                    reservation@swamisamarthpg.com 
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#FF6403' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Shree Swami Samarth PG  <br />
                                                        M.No. 03065, No. 258/1/3, Mukai Nagar, B.H. MRF Showroom, Pune 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Pginpune;